import { useStyles } from "./SectionNote.styles";
import type { ISectionNoteProps } from "./SectionNote.types";

export const SectionNote = ({ children }: ISectionNoteProps): JSX.Element => {
  const styles = useStyles();

  return <div className={styles.note}>{children}</div>;
};
